/**
 * This file is automatically generated.
 **/
import { ActionType } from './action/ActionType'
import ActionHandler from './ActionHandler.type'

import { handleCancelFactoryOrderAction, CancelFactoryOrderActionSchema } from './action/Game/CancelFactoryOrderAction'
import { handleEndGameAction, EndGameActionSchema } from './action/Game/EndGameAction'
import { handleEndRoundAction, EndRoundActionSchema } from './action/Game/EndRoundAction'
import { handleEndTurnAction, EndTurnActionSchema } from './action/Game/EndTurnAction'
import { handleMoveUnitAction, MoveUnitActionSchema } from './action/Game/MoveUnitAction'
import { handlePlaceFactoryOrderAction, PlaceFactoryOrderActionSchema } from './action/Game/PlaceFactoryOrderAction'
import { handleStartRoundAction, StartRoundActionSchema } from './action/Game/StartRoundAction'
import { handleStartTurnAction, StartTurnActionSchema } from './action/Game/StartTurnAction'
import { handleClaimPlayerSlotAction, ClaimPlayerSlotActionSchema } from './action/Lobby/ClaimPlayerSlotAction'
import { handleDeleteLobbyAction, DeleteLobbyActionSchema } from './action/Lobby/DeleteLobbyAction'
import { handleKickPlayerSlotAction, KickPlayerSlotActionSchema } from './action/Lobby/KickPlayerSlotAction'
import { handleLeavePlayerSlotAction, LeavePlayerSlotActionSchema } from './action/Lobby/LeavePlayerSlotAction'
import { handlePatchConfigAction, PatchConfigActionSchema } from './action/Lobby/PatchConfigAction'
import { handleReservePlayerSlotAction, ReservePlayerSlotActionSchema } from './action/Lobby/ReservePlayerSlotAction'
import { handleRestoreLobbyAction, RestoreLobbyActionSchema } from './action/Lobby/RestoreLobbyAction'
import { handleSetBotPlayerSlotAction, SetBotPlayerSlotActionSchema } from './action/Lobby/SetBotPlayerSlotAction'
import { handleStartNewGameAction, StartNewGameActionSchema } from './action/Lobby/StartNewGameAction'
import { handleAddPlayerAction, AddPlayerActionSchema } from './action/Map/AddPlayerAction'
import { handleDeleteMapAction, DeleteMapActionSchema } from './action/Map/DeleteMapAction'
import { handleDeletePlayerAction, DeletePlayerActionSchema } from './action/Map/DeletePlayerAction'
import { handleEraseTileAction, EraseTileActionSchema } from './action/Map/EraseTileAction'
import { handleMapToLobbyAction, MapToLobbyActionSchema } from './action/Map/MapToLobbyAction'
import { handlePaintTileAction, PaintTileActionSchema } from './action/Map/PaintTileAction'
import { handlePatchMapAction, PatchMapActionSchema } from './action/Map/PatchMapAction'
import { handlePatchPlayerAction, PatchPlayerActionSchema } from './action/Map/PatchPlayerAction'
import { handlePublishMapAction, PublishMapActionSchema } from './action/Map/PublishMapAction'
import { handleRestoreMapAction, RestoreMapActionSchema } from './action/Map/RestoreMapAction'
import { handleRotateEntityAction, RotateEntityActionSchema } from './action/Map/RotateEntityAction'
import { handleRownipulatorAddRowAction, RownipulatorAddRowActionSchema } from './action/Map/RownipulatorAddRowAction'
import { handleRownipulatorDeleteRowAction, RownipulatorDeleteRowActionSchema } from './action/Map/RownipulatorDeleteRowAction'
import { handleRownipulatorDuplicateRowAction, RownipulatorDuplicateRowActionSchema } from './action/Map/RownipulatorDuplicateRowAction'
import { handleSetEntityElevationAction, SetEntityElevationActionSchema } from './action/Map/SetEntityElevationAction'
import { handleSetEntsAction, SetEntsActionSchema } from './action/Map/SetEntsAction'
import { handleSetStateAction, SetStateActionSchema } from './action/Map/SetStateAction'
import { handleUnpublishMapAction, UnpublishMapActionSchema } from './action/Map/UnpublishMapAction'

export type ActionSchemaUnion = typeof CancelFactoryOrderActionSchema | typeof EndGameActionSchema | typeof EndRoundActionSchema | typeof EndTurnActionSchema | typeof MoveUnitActionSchema | typeof PlaceFactoryOrderActionSchema | typeof StartRoundActionSchema | typeof StartTurnActionSchema | typeof ClaimPlayerSlotActionSchema | typeof DeleteLobbyActionSchema | typeof KickPlayerSlotActionSchema | typeof LeavePlayerSlotActionSchema | typeof PatchConfigActionSchema | typeof ReservePlayerSlotActionSchema | typeof RestoreLobbyActionSchema | typeof SetBotPlayerSlotActionSchema | typeof StartNewGameActionSchema | typeof AddPlayerActionSchema | typeof DeleteMapActionSchema | typeof DeletePlayerActionSchema | typeof EraseTileActionSchema | typeof MapToLobbyActionSchema | typeof PaintTileActionSchema | typeof PatchMapActionSchema | typeof PatchPlayerActionSchema | typeof PublishMapActionSchema | typeof RestoreMapActionSchema | typeof RotateEntityActionSchema | typeof RownipulatorAddRowActionSchema | typeof RownipulatorDeleteRowActionSchema | typeof RownipulatorDuplicateRowActionSchema | typeof SetEntityElevationActionSchema | typeof SetEntsActionSchema | typeof SetStateActionSchema | typeof UnpublishMapActionSchema

type ActionHandlerTuple = [ActionType, ActionSchemaUnion, ActionHandler];

// const actionHandlersSet = new Map<ActionType, ActionHandler>()

// actionHandlersSet.set(ActionType.Game.CancelFactoryOrder, handleCancelFactoryOrderAction as ActionHandler)
// actionHandlersSet.set(ActionType.Game.EndGame, handleEndGameAction as ActionHandler)
// actionHandlersSet.set(ActionType.Game.EndRound, handleEndRoundAction as ActionHandler)
// actionHandlersSet.set(ActionType.Game.EndTurn, handleEndTurnAction as ActionHandler)
// actionHandlersSet.set(ActionType.Game.MoveUnit, handleMoveUnitAction as ActionHandler)
// actionHandlersSet.set(ActionType.Game.PlaceFactoryOrder, handlePlaceFactoryOrderAction as ActionHandler)
// actionHandlersSet.set(ActionType.Game.StartRound, handleStartRoundAction as ActionHandler)
// actionHandlersSet.set(ActionType.Game.StartTurn, handleStartTurnAction as ActionHandler)
// actionHandlersSet.set(ActionType.Lobby.ClaimPlayerSlot, handleClaimPlayerSlotAction as ActionHandler)
// actionHandlersSet.set(ActionType.Lobby.DeleteLobby, handleDeleteLobbyAction as ActionHandler)
// actionHandlersSet.set(ActionType.Lobby.KickPlayerSlot, handleKickPlayerSlotAction as ActionHandler)
// actionHandlersSet.set(ActionType.Lobby.LeavePlayerSlot, handleLeavePlayerSlotAction as ActionHandler)
// actionHandlersSet.set(ActionType.Lobby.PatchConfig, handlePatchConfigAction as ActionHandler)
// actionHandlersSet.set(ActionType.Lobby.ReservePlayerSlot, handleReservePlayerSlotAction as ActionHandler)
// actionHandlersSet.set(ActionType.Lobby.RestoreLobby, handleRestoreLobbyAction as ActionHandler)
// actionHandlersSet.set(ActionType.Lobby.SetBotPlayerSlot, handleSetBotPlayerSlotAction as ActionHandler)
// actionHandlersSet.set(ActionType.Lobby.StartNewGame, handleStartNewGameAction as ActionHandler)
// actionHandlersSet.set(ActionType.Map.AddPlayer, handleAddPlayerAction as ActionHandler)
// actionHandlersSet.set(ActionType.Map.DeleteMap, handleDeleteMapAction as ActionHandler)
// actionHandlersSet.set(ActionType.Map.DeletePlayer, handleDeletePlayerAction as ActionHandler)
// actionHandlersSet.set(ActionType.Map.EraseTile, handleEraseTileAction as ActionHandler)
// actionHandlersSet.set(ActionType.Map.MapToLobby, handleMapToLobbyAction as ActionHandler)
// actionHandlersSet.set(ActionType.Map.PaintTile, handlePaintTileAction as ActionHandler)
// actionHandlersSet.set(ActionType.Map.PatchMap, handlePatchMapAction as ActionHandler)
// actionHandlersSet.set(ActionType.Map.PatchPlayer, handlePatchPlayerAction as ActionHandler)
// actionHandlersSet.set(ActionType.Map.PublishMap, handlePublishMapAction as ActionHandler)
// actionHandlersSet.set(ActionType.Map.RestoreMap, handleRestoreMapAction as ActionHandler)
// actionHandlersSet.set(ActionType.Map.RotateEntity, handleRotateEntityAction as ActionHandler)
// actionHandlersSet.set(ActionType.Map.RownipulatorAddRow, handleRownipulatorAddRowAction as ActionHandler)
// actionHandlersSet.set(ActionType.Map.RownipulatorDeleteRow, handleRownipulatorDeleteRowAction as ActionHandler)
// actionHandlersSet.set(ActionType.Map.RownipulatorDuplicateRow, handleRownipulatorDuplicateRowAction as ActionHandler)
// actionHandlersSet.set(ActionType.Map.SetEntityElevation, handleSetEntityElevationAction as ActionHandler)
// actionHandlersSet.set(ActionType.Map.SetEnts, handleSetEntsAction as ActionHandler)
// actionHandlersSet.set(ActionType.Map.SetState, handleSetStateAction as ActionHandler)
// actionHandlersSet.set(ActionType.Map.UnpublishMap, handleUnpublishMapAction as ActionHandler)

const actionHandlersList : Array<ActionHandlerTuple> = [
  [ActionType.Game.CancelFactoryOrder,
    CancelFactoryOrderActionSchema,
    handleCancelFactoryOrderAction as ActionHandler],
  [ActionType.Game.EndGame,
    EndGameActionSchema,
    handleEndGameAction as ActionHandler],
  [ActionType.Game.EndRound,
    EndRoundActionSchema,
    handleEndRoundAction as ActionHandler],
  [ActionType.Game.EndTurn,
    EndTurnActionSchema,
    handleEndTurnAction as ActionHandler],
  [ActionType.Game.MoveUnit,
    MoveUnitActionSchema,
    handleMoveUnitAction as ActionHandler],
  [ActionType.Game.PlaceFactoryOrder,
    PlaceFactoryOrderActionSchema,
    handlePlaceFactoryOrderAction as ActionHandler],
  [ActionType.Game.StartRound,
    StartRoundActionSchema,
    handleStartRoundAction as ActionHandler],
  [ActionType.Game.StartTurn,
    StartTurnActionSchema,
    handleStartTurnAction as ActionHandler],
  [ActionType.Lobby.ClaimPlayerSlot,
    ClaimPlayerSlotActionSchema,
    handleClaimPlayerSlotAction as ActionHandler],
  [ActionType.Lobby.DeleteLobby,
    DeleteLobbyActionSchema,
    handleDeleteLobbyAction as ActionHandler],
  [ActionType.Lobby.KickPlayerSlot,
    KickPlayerSlotActionSchema,
    handleKickPlayerSlotAction as ActionHandler],
  [ActionType.Lobby.LeavePlayerSlot,
    LeavePlayerSlotActionSchema,
    handleLeavePlayerSlotAction as ActionHandler],
  [ActionType.Lobby.PatchConfig,
    PatchConfigActionSchema,
    handlePatchConfigAction as ActionHandler],
  [ActionType.Lobby.ReservePlayerSlot,
    ReservePlayerSlotActionSchema,
    handleReservePlayerSlotAction as ActionHandler],
  [ActionType.Lobby.RestoreLobby,
    RestoreLobbyActionSchema,
    handleRestoreLobbyAction as ActionHandler],
  [ActionType.Lobby.SetBotPlayerSlot,
    SetBotPlayerSlotActionSchema,
    handleSetBotPlayerSlotAction as ActionHandler],
  [ActionType.Lobby.StartNewGame,
    StartNewGameActionSchema,
    handleStartNewGameAction as ActionHandler],
  [ActionType.Map.AddPlayer,
    AddPlayerActionSchema,
    handleAddPlayerAction as ActionHandler],
  [ActionType.Map.DeleteMap,
    DeleteMapActionSchema,
    handleDeleteMapAction as ActionHandler],
  [ActionType.Map.DeletePlayer,
    DeletePlayerActionSchema,
    handleDeletePlayerAction as ActionHandler],
  [ActionType.Map.EraseTile,
    EraseTileActionSchema,
    handleEraseTileAction as ActionHandler],
  [ActionType.Map.MapToLobby,
    MapToLobbyActionSchema,
    handleMapToLobbyAction as ActionHandler],
  [ActionType.Map.PaintTile,
    PaintTileActionSchema,
    handlePaintTileAction as ActionHandler],
  [ActionType.Map.PatchMap,
    PatchMapActionSchema,
    handlePatchMapAction as ActionHandler],
  [ActionType.Map.PatchPlayer,
    PatchPlayerActionSchema,
    handlePatchPlayerAction as ActionHandler],
  [ActionType.Map.PublishMap,
    PublishMapActionSchema,
    handlePublishMapAction as ActionHandler],
  [ActionType.Map.RestoreMap,
    RestoreMapActionSchema,
    handleRestoreMapAction as ActionHandler],
  [ActionType.Map.RotateEntity,
    RotateEntityActionSchema,
    handleRotateEntityAction as ActionHandler],
  [ActionType.Map.RownipulatorAddRow,
    RownipulatorAddRowActionSchema,
    handleRownipulatorAddRowAction as ActionHandler],
  [ActionType.Map.RownipulatorDeleteRow,
    RownipulatorDeleteRowActionSchema,
    handleRownipulatorDeleteRowAction as ActionHandler],
  [ActionType.Map.RownipulatorDuplicateRow,
    RownipulatorDuplicateRowActionSchema,
    handleRownipulatorDuplicateRowAction as ActionHandler],
  [ActionType.Map.SetEntityElevation,
    SetEntityElevationActionSchema,
    handleSetEntityElevationAction as ActionHandler],
  [ActionType.Map.SetEnts,
    SetEntsActionSchema,
    handleSetEntsAction as ActionHandler],
  [ActionType.Map.SetState,
    SetStateActionSchema,
    handleSetStateAction as ActionHandler],
  [ActionType.Map.UnpublishMap,
    UnpublishMapActionSchema,
    handleUnpublishMapAction as ActionHandler],
]


export default actionHandlersList